import { store } from "@/store/store";
import { refreshToken, removeAccessToken } from "./apiClient";

async function CheckAuth(): Promise<boolean> {
    try {
        const state = store.getState();
        const user = state.user.value;

        if (!user) {
            removeAccessToken();
        }

        const accessToken = localStorage.getItem("are@accessToken");

        if (!accessToken || accessToken === "undefined") {
            const refreshed = await refreshToken();
            if (!refreshed) {
                return false;
            }
        }

        const newAccessToken = localStorage.getItem("are@accessToken");

        if (!newAccessToken || newAccessToken === "undefined") {
            return false;
        }

        return true;
    } catch (error) {
        return false;
    }
}

export default CheckAuth;
